export default __webpack_public_path__ + "static/media/buyer_benefits_3.ad08e206.svg";